// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Proxima Nova'; }

.addBtn {
  margin-left: 16px; }
  .addBtn .ant-btn {
    background: #586f80;
    border-radius: 4px;
    height: 28px;
    color: white;
    font-weight: 600;
    text-align: center;
    border: none !important;
    transition: all 0.5s linear;
    margin: 0px 10px; }
    .addBtn .ant-btn:hover, .addBtn .ant-btn:focus {
      color: white;
      background: #586f80;
      border: none; }

.ant-tabs-top > .ant-tabs-nav {
  margin: 5px 0px 24px 0px !important; }

.ant-btn .ant-btn-primary {
  position: absolute;
  top: 81px;
  right: 16px; }

.abstractTabs .ant-tabs-tab {
  height: 37px;
  min-width: 180px;
  border-radius: 8px !important;
  background: #f0f4f7 !important; }

.abstractTabs .ant-tabs-tab.ant-tabs-tab-with-remove {
  display: flex;
  justify-content: space-between;
  height: 37px;
  min-width: 180px; }

.abstractTabs .ant-tabs-tab.ant-tabs-tab-active {
  height: 37px;
  min-width: 180px;
  background: #fff !important;
  font-weight: 600;
  font-size: 14px; }
  .abstractTabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: #323232 !important;
    line-height: 17px; }

.abstractTabs .ant-tabs-tab-btn {
  color: #637f92;
  line-height: 17px; }

.actionbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px; }
  .actionbar .align-bottom {
    align-items: baseline; }
  .actionbar h2 {
    font-size: 24px;
    font-weight: 600;
    margin-right: 8px;
    margin-bottom: 0; }
  .actionbar .dummy-btn {
    margin-left: 16px; }

.flex {
  display: flex; }

.align-center {
  align-items: center; }

.align-end {
  align-items: flex-end; }

.dropdown-group {
  margin-bottom: 20px; }
  .dropdown-group .ant-picker-input ::placeholder {
    font-size: 16px;
    line-height: 17px;
    color: #586f80; }

.ant-table-column-sorter-up.active,
.ant-table-column-sorter-down.active {
  color: #586f80 !important; }

.ant-table-column-title {
  z-index: 0 !important; }

.ant-pagination-item-active {
  border-color: #586f80 !important; }
  .ant-pagination-item-active a {
    color: #586f80 !important; }

.ant-tag {
  border: none !important; }

.ant-pagination-item {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important; }

.nameClick:hover {
  cursor: pointer; }

.ant-table-thead .ant-table-cell {
  background-color: #f8fafb !important; }

.ant-table-thead tr .ant-table-cell {
  font-size: 16px !important;
  font-weight: 600 !important;
  color: #637f92; }

.ant-table-thead tr .ant-table-column-title {
  font-size: 16px !important; }

.ant-table-tbody .ant-tag {
  font-size: 16px;
  font-weight: 600; }

.ant-table-tbody tr td {
  font-size: 16px !important;
  font-weight: 400;
  color: #323232 !important; }

.landing-container .ant-table-cell {
  max-width: 300px; }

.date-filter.date-filter {
  padding-top: 8px;
  padding-bottom: 8px;
  margin-right: 6px;
  color: #586f80;
  outline: none;
  border-radius: 50px;
  line-height: 20px;
  width: 125px; }
  .date-filter.date-filter:focus, .date-filter.date-filter:hover {
    color: #586f80;
    border: 1px solid #586f80;
    outline: none; }

.date-filter.ant-picker-focused {
  border-color: #586f80;
  box-shadow: none; }
`, "",{"version":3,"sources":["webpack://./src/pages/Entity/entity.scss"],"names":[],"mappings":"AAAA;EACI,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,2BAA2B,EAAA;;AAG/B;EACI,iBAAiB,EAAA;EADrB;IAIQ,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;IACvB,2BAA2B;IAC3B,gBAAgB,EAAA;IAZxB;MAgBY,YAAY;MACZ,mBAAmB;MACnB,YAAY,EAAA;;AAKxB;EACI,mCAAmC,EAAA;;AAGvC;EACI,kBAAkB;EAClB,SAAS;EACT,WAAW,EAAA;;AAGf;EAEQ,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;EAC7B,8BAA8B,EAAA;;AALtC;EASQ,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB,EAAA;;AAZxB;EAgBQ,YAAY;EACZ,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe,EAAA;EApBvB;IAuBY,yBAAyB;IACzB,iBAAiB,EAAA;;AAxB7B;EA6BQ,cAAc;EACd,iBAAiB,EAAA;;AAIzB;EACI,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB,EAAA;EAJvB;IAOQ,qBAAqB,EAAA;EAP7B;IAWQ,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB,EAAA;EAdxB;IAkBQ,iBAAiB,EAAA;;AAIzB;EACI,aAAa,EAAA;;AAGjB;EACI,mBAAmB,EAAA;;AAGvB;EACI,qBAAqB,EAAA;;AAGzB;EACI,mBAAmB,EAAA;EADvB;IAKY,eAAe;IACf,iBAAiB;IACjB,cAAc,EAAA;;AAK1B;;EAEI,yBAAyB,EAAA;;AAG7B;EACI,qBAAqB,EAAA;;AAGzB;EACI,gCAAgC,EAAA;EADpC;IAIQ,yBAAyB,EAAA;;AAGjC;EACI,uBAAuB,EAAA;;AAG3B;EACI,wBAAwB;EACxB,kCAAkC;EAClC,8BAA8B,EAAA;;AAGlC;EACI,eAAe,EAAA;;AAGnB;EACI,oCAAoC,EAAA;;AAGxC;EAGY,0BAA0B;EAC1B,2BAA2B;EAC3B,cAAc,EAAA;;AAL1B;EASY,0BAA0B,EAAA;;AAKtC;EAEQ,eAAe;EACf,gBAAgB,EAAA;;AAHxB;EAQY,0BAA0B;EAC1B,gBAAgB;EAChB,yBAAyB,EAAA;;AAKrC;EAEQ,gBAAgB,EAAA;;AAKxB;EACI,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,YAAY,EAAA;EARhB;IAYQ,cAAc;IACd,yBAAyB;IACzB,aAAa,EAAA;;AAIrB;EACI,qBAAqB;EACrB,gBAAgB,EAAA","sourcesContent":["* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n    font-family: 'Proxima Nova';\n}\n\n.addBtn {\n    margin-left: 16px;\n\n    .ant-btn {\n        background: #586f80;\n        border-radius: 4px;\n        height: 28px;\n        color: white;\n        font-weight: 600;\n        text-align: center;\n        border: none !important;\n        transition: all 0.5s linear;\n        margin: 0px 10px;\n\n        &:hover,\n        &:focus {\n            color: white;\n            background: #586f80;\n            border: none;\n        }\n    }\n}\n\n.ant-tabs-top > .ant-tabs-nav {\n    margin: 5px 0px 24px 0px !important;\n}\n\n.ant-btn .ant-btn-primary {\n    position: absolute;\n    top: 81px;\n    right: 16px;\n}\n\n.abstractTabs {\n    .ant-tabs-tab {\n        height: 37px;\n        min-width: 180px;\n        border-radius: 8px !important;\n        background: #f0f4f7 !important;\n    }\n\n    .ant-tabs-tab.ant-tabs-tab-with-remove {\n        display: flex;\n        justify-content: space-between;\n        height: 37px;\n        min-width: 180px;\n    }\n\n    .ant-tabs-tab.ant-tabs-tab-active {\n        height: 37px;\n        min-width: 180px;\n        background: #fff !important;\n        font-weight: 600;\n        font-size: 14px;\n\n        .ant-tabs-tab-btn {\n            color: #323232 !important;\n            line-height: 17px;\n        }\n    }\n\n    .ant-tabs-tab-btn {\n        color: #637f92;\n        line-height: 17px;\n    }\n}\n\n.actionbar {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n\n    .align-bottom {\n        align-items: baseline;\n    }\n\n    h2 {\n        font-size: 24px;\n        font-weight: 600;\n        margin-right: 8px;\n        margin-bottom: 0;\n    }\n\n    .dummy-btn {\n        margin-left: 16px;\n    }\n}\n\n.flex {\n    display: flex;\n}\n\n.align-center {\n    align-items: center;\n}\n\n.align-end {\n    align-items: flex-end;\n}\n\n.dropdown-group {\n    margin-bottom: 20px;\n\n    .ant-picker-input {\n        ::placeholder {\n            font-size: 16px;\n            line-height: 17px;\n            color: #586f80;\n        }\n    }\n}\n\n.ant-table-column-sorter-up.active,\n.ant-table-column-sorter-down.active {\n    color: #586f80 !important;\n}\n\n.ant-table-column-title {\n    z-index: 0 !important;\n}\n\n.ant-pagination-item-active {\n    border-color: #586f80 !important;\n\n    a {\n        color: #586f80 !important;\n    }\n}\n.ant-tag {\n    border: none !important;\n}\n\n.ant-pagination-item {\n    display: flex !important;\n    justify-content: center !important;\n    align-items: center !important;\n}\n\n.nameClick:hover {\n    cursor: pointer;\n}\n\n.ant-table-thead .ant-table-cell {\n    background-color: #f8fafb !important;\n}\n\n.ant-table-thead {\n    tr {\n        .ant-table-cell {\n            font-size: 16px !important;\n            font-weight: 600 !important;\n            color: #637f92;\n        }\n\n        .ant-table-column-title {\n            font-size: 16px !important;\n        }\n    }\n}\n\n.ant-table-tbody {\n    .ant-tag {\n        font-size: 16px;\n        font-weight: 600;\n    }\n\n    tr {\n        td {\n            font-size: 16px !important;\n            font-weight: 400;\n            color: #323232 !important;\n        }\n    }\n}\n\n.landing-container {\n    .ant-table-cell {\n        max-width: 300px;\n    }\n}\n\n// Date Filter\n.date-filter.date-filter {\n    padding-top: 8px;\n    padding-bottom: 8px;\n    margin-right: 6px;\n    color: #586f80;\n    outline: none;\n    border-radius: 50px;\n    line-height: 20px;\n    width: 125px;\n\n    &:focus,\n    &:hover {\n        color: #586f80;\n        border: 1px solid #586f80;\n        outline: none;\n    }\n}\n\n.date-filter.ant-picker-focused {\n    border-color: #586f80;\n    box-shadow: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
